import { useMutation } from '@apollo/client'
import {
  CREATE_TRUCK,
  UPDATE_TRUCK,
} from '../../../../graphql/Catalog/Trucks/trucks'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import { useEffect, useRef, useState } from 'react'
import ModalContent from '../../../Global/ModalContent'
import { useHistory, useParams } from 'react-router-dom'
import FormTruck from './Components/FormTruck'

const TrucksNew = ({
  truckId,
  setTruckId,
  refetchMain,
  modalForm = false,
  setModalForm,
  modalId = 'modal-truck',
}) => {
  const { id: _id } = useParams()
  const refModalForm = useRef(null)
  const history = useHistory()
  const { hideLoading, showLoading } = useLoading()
  const [closeModal, setCloseModal] = useState(false)

  const [createTruck] = useMutation(CREATE_TRUCK)
  const [updateTruck] = useMutation(UPDATE_TRUCK)

  //MODAL
  const [modalContent, setModalContent] = useState({
    title: truckId || _id ? 'Editar Camión' : 'Nuevo Camión',
    content: null,
    size: 'extra',
    modalId: modalForm ? modalId : null,
  })

  useEffect(() => {
    if (!modalForm) return
    if (modalForm) {
      setModalContent({
        title: truckId ? 'Editar Camión' : 'Nuevo Camión',
        content: (
          <>
            <FormTruck
              submitAction={onSubmit}
              truckId={truckId}
              modeModal={modalForm}
            />
          </>
        ),
        size: 'extra',
        modalId: 'modal-truck',
      })
    }
  }, [modalForm])

  useEffect(() => {
    if (modalContent.modalId) {
      document.getElementById(`spanModal${modalContent.modalId}`).click()
    }
  }, [modalContent])

  useEffect(() => {
    if (closeModal) {
      refModalForm.current.click()
      setCloseModal(false)
    }
  }, [closeModal])

  const onSubmit = async (data) => {
    showLoading()
    try {
      if (truckId) {
        const { data: dataUpdate } = await updateTruck({
          variables: {
            updateTruckId: +truckId,
            truck: {
              plate_number: data.plate_number,
              type: data.type,
              status: data.status,
              capacity: +data.capacity,
              user_id: +data.user_id,
            },
          },
        })

        if (dataUpdate.updateTruck) {
          if (modalForm) await refetchMain()
          return toastSweetAlert(
            {
              mode: 'ok',
              message: 'Camión actualizado correctamente',
            },
            !modalForm ? history.push('/trucks') : ''
          )
        }
      }

      const { data: dataCreate } = await createTruck({
        variables: {
          truck: {
            plate_number: data.plate_number,
            type: data.type,
            status: data.status,
            capacity: +data.capacity,
            user_id: +data.user_id,
          },
        },
      })

      if (dataCreate.createTruck) {
        if (modalForm) await refetchMain()
        return toastSweetAlert(
          {
            mode: 'ok',
            message: 'Camión creado correctamente',
          },
          !modalForm ? history.push('/trucks') : ''
        )
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
      if (modalForm) setCloseModal(true)
    }
  }
  return (
    <>
      {modalForm ? (
        <>
          <span
            id={`spanModal${modalContent.modalId}`}
            className="invisible"
            data-toggle="modal"
            data-target={`#${modalContent.modalId}`}
            data-backdrop="static"
            data-keyboard="false"
            data-dismiss="modal"
            ref={refModalForm}
          ></span>

          <ModalContent
            idModal={modalContent.modalId}
            title={modalContent.title}
            size={modalContent.size}
            onClose={() => {
              setModalContent({
                title: '',
                content: null,
                modalId: null,
                size: 'extra',
              })
              setModalForm(false)
              setTruckId(null)
            }}
            content={modalContent.content}
          />
        </>
      ) : (
        <>
          <FormTruck
            submitAction={onSubmit}
            truckId={_id}
            modeModal={modalForm}
          />
        </>
      )}
    </>
  )
}

export default TrucksNew
